import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Córdoba',
  text: '"Llevaba años queriendo formarme en Reiki de verdad. En una semana tenía mi primer cliente. El protocolo de sintonizaciones es oro puro."'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  text: '"El material más completo que vi en español. El certificado está enmarcado en mi consultorio y mis clientes lo ven apenas entran."'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Buenos Aires',
  text: '"Ya hacía terapia floral. El MegaPack completó todo lo que me faltaba. Ahora tengo lista de espera."'
}];
export function TestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#faf5fc] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0]" data-id="element-471">
      <div className="container mx-auto max-w-5xl" data-id="element-472">
        <div ref={ref1} className={`reveal grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-473">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-white border border-[#e8d5f0] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-474">
              <div className="flex items-center gap-3 mb-4" data-id="element-475">
                <div className="w-10 h-10 rounded-full bg-[#f3e9f7] border border-[#e8d5f0] flex items-center justify-center text-[#3d2a5f] font-bold text-sm" data-id="element-476">
                  {t.initials}
                </div>
                <div data-id="element-477">
                  <div className="flex text-[#c9a14d] text-sm mb-0.5" data-id="element-478">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-[#3d2a5f] font-bold text-sm" data-id="element-479">
                    {t.name}{' '}
                    <span className="text-[#6b5a85] font-normal" data-id="element-480">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-[#6b5a85] text-sm leading-relaxed italic" data-id="element-481">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}